import { useQuery } from "@tanstack/react-query"
import { getPvpRouletteRound } from "@/shared/api/endpoints"

export function useRoundDetail(roundId: string | null) {
  return useQuery({
    queryKey: ["roundDetail", roundId],
    queryFn: () => getPvpRouletteRound(roundId!),
    enabled: !!roundId,
    staleTime: Infinity, // resolved rounds don't change
  })
}
